import { createTheme } from '@one-thd/sui-atomic-components';

const THDWickedWoodsGreen = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand-500'
    }
  }
});

THDWickedWoodsGreen.palette['--sui-palette-background-primary'] = '26 27 21';

export { THDWickedWoodsGreen };
